define( [
	"../../core"
], function( jQuery ) {
	return jQuery.now();
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/ajax/var/nonce.js
// module id = 854
// module chunks = 0